import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/laboratorial_analysis',
  title: 'Análises Laboratoriais',
  endpoint: '/app/laboratory_analysis',
}
